document.addEventListener("DOMContentLoaded", function() {
    var passwordForm = document.getElementById("password-form");
    var password = passwordForm.dataset.password;

    var submitButton = document.getElementById("submit-btn");
    var passwordInput = document.getElementById("password-input");
    var error_text = document.getElementById("error_text")

    var attempts = 0; // Add a counter for password attempts

    submitButton.addEventListener("click", function() {
        var enteredPassword = passwordInput.value;
        if (enteredPassword === password) {
            // Password is correct, show protected content
            passwordForm.style.display = "none";
            document.getElementById("protected-content").classList.remove("hidden");
        } else {
            attempts += 1;
            if (attempts >= 3) {
                window.location.href = "https://www.storkexchange.co";
            } else {
                error_text.style.display = "block";
                error_text.textContent = "Incorrect password";
            }
        }
    });
    document.getElementById("home").onclick = function () {
      window.location.href = "https://storkexchange.co";
    };
});